export const main = {
	yhxm:'ئۇچۇرغۇچىڭىزىڭ ئاتى',
	qrxx:'ئۇچۇرلارنىڭ ئەككەلۈشىنى تەكشۈرۈڭ',
    mmdl:'مەخپى نومۇر ئارقىلىق كىرىش',
    yzmdl:'ئېنىقلىما نومۇر ئارقىلىق كىرىش',
    sjhm:"يان تېلىفون نومۇر",
    qsrmm:'مەخپى نومۇرنى كىرگۈزۈش',
    wjmm:'مەخپى نومۇرنى قايتۇرۇش',
    dl:'كىرىش',
    zcxzh:'يېڭى ھېسابات نومۇرىنى ئەنگە ئالدۇرۇش',
    yzm:'ئېنىقلىما نومۇر',
    hqyzm:'ئېنىقلىما نومۇرغا ئېرىشىش',
    sryx:'ئېلخەت نومۇرىنى كىرگۈزۈش',
    zcsrmm:'مەخپى نومۇرنى قايتا كىرگۈزۈش',
    yqm:'ئەگەر لۇتفەن dostum چىقىرىش كودىسى/ dostum چىقىرغۇچىنىڭ سېركىت تېلېفون نومۇرىسىنى كىرگۈزۈڭ',
    sjyz:'تېلفۇن نومۇر ئارقىلىق دەلىللەش',
    yxyz:'ئېلخەت نومۇرى ئارقىلىق دەلىللەش',
    tyxyhzc:'ئابونېتلار كېلىشىمى ۋە شىخسىي مەخپىيەتلىك سىياسىتىگە قوشۇلىمەن',
    ty:'ئوقۇپ بولدۇم ۋە قوشۇلىمەن',
    yhxy:'ئابونىتلار كېلىشىمى',
    yszc:'شەخسىي مەخپىيەتلىك سىياسىتى',
    zce:'ئەنگە ئالدۇرۇش',
    zyzhljdl:'ھېسابات نومۇرى مەۋجۇت، كىرىش',
    wdzc:'مىنىڭ مەبلىغىم',
    wdzh:'مىنىڭ ھېسابات نومۇرىم',
    tbgl:'ماس قەدەمدە باشقۇرۇش',
    fbxh:'سېگىنال يوللاش',
    xhsc:'سېگىنال بازىرى',
    czsc:'مەشغۇلات قوللانمىسى',
    tcxh:'سېگىنالدىن چېكىنىش',
    ye:'قالدۇق پۇل',
    jz:'ساپ قىممەت',
    jyss:'سودا سانى',
    ccyl:'ئامبار پايدىسى',
    xvh:'تەرتىپ نومۇرى',
    sftb:'ماس قەدەممۇ ياقمۇ',
    fwq:'مەشغۇلات سېستىمىسى',
    zh:'ھېسابات نومۇرى',
    zyk:'ئومۇمىي پايدا زىيان',
    kds:'تاق سان ئېچىش',
    zhzt:'ھېسابات نومۇرى ئەھۋالى',
    cz:'مەشغۇلات',
    s:'ھەئە',
    f:'ياق',
    zc:'نورمال',
    yc:'بىنورمال',
    ck:'كۆرۈش',
    cpyk:'مەھسۇلات پايدا زىيىنى',
    zss:'ئومۇمىي سان',
    jypz:'سودا تۈرى',
    sy:'پايدا',
    sszb:'ئېگىلىگەن نىسبىتى',
    cczh:'ئامبار جەملىمىسى',
    ddh:'تالون نومۇرى',
    jyl:'سودا مىقدارى',
    kcsj:'ئامبار ئاچقان ۋاقىت',
    kcjg:'ئامبار قىممىتى',
    bjjg:'بەلگىلەنگەن باھا',
    zyzs:'پايدىنى توختىتىش/زىياننى توختىتىش',
    gylx:'ئۆسۈم',
    yk:'پايدا ـ زىيان',
    xzcksj:'ھېسابات نومۇرى ئىچىدىن كۆرمەكچى بولغان سانلىق مەلۇماتنى تاللاڭ',
    tbyk:'ماس قەدەملىك پايدا ـ زىيان',
    ccsj:'ئامبارنى تەڭشەش ۋاقتى',
    pcsj:'ئامبارنى تازلاش ۋاقتى',
    tjzh:'ھېسابات نومۇرىنى قوشۇش',
    bz:'ئەسكەرتىش',
    sfwxh:'سېگىنال ئىچىدىمۇ ياقمۇ',
    tbzt:'ماس قەدەملىك ھالەت',
    ytb:'ماس قەدەمدە بولۇپ بولدى',
    wtb:'ماس قەدەملىك بولمىدى',
    qyjy:'قوللىنىش/قوللىنىشنى توختىتىش',
    yqy:'ئىشلىتىش قوزغىلىپ بولدى',
    yjy:'قوللىنىش توختىتىلدى',
    xgzhmm:'ھېسابات نومۇرىنى ئۆزگەرتىش',
    gbxh:'سېگىنالنى ئىتىش',
    sczh:'ھېسابات نومۇرىنى يۇيۇش',
    qw:'ئىلگىرلەش',
    y:'بەت',
    tjglzh:'باغلانغان ھېسابات نومۇرىنى قوشۇش',
    qxz:'تاللاڭ',
    qsrzh:'ھېسابات نومۇرىنى كىرگۈزۈڭ',
    mm:'مەخپى نومۇر',
    qsrbz:'قوشۇمچەئەسكەرتىشنى كىرگۈزۈڭ',
    sjsqxhts:'ئەسلى ھېسابات نومۇرى ئىگىسىنىڭ مەخپى نومۇرىنى كىرگۈزگەندىن كېيىن دەرىجىنى مەھەللە سېگىنالىغا ئۆستۈرگىلى بولىدۇ',
    qr:'مۇقۇملاشتۇرۇش',
    qx:'ئۈچۈرۈش',
    zhjy:'ھېسابات نومۇرى ****نى ئىشلىتىشتىن توختىتىشقا تەڭشەمسىز',
    zhqy:'ھېسابات نومۇرى ****نى ئىشلىتىشكە كىرىشتۈرۈشكە تەڭشەمسىز',
    dqdlmm:'ھازىرقى كىرىش مەخپى نومۇرى',
    xzhmm:'يېڭى ھېسابات نومۇرى مەخپى نومۇرى',
    qrxmm:'يېڭى مەخپى نومۇرنى مۇقۇملاڭ',
    qsrdqdlmm:'ھازىرقى كىرىش مەخپى نومۇرىنى كىرگۈزۈڭ',
    qsrxmm:'يېڭى مەخپى نومۇرنى كىرگۈزۈڭ',
    qzcsrxmm:'يېڭى مەخپى نومۇرنى يەنە بىر قېتىم كىرگۈزۈڭ',
    yhzl:'ئابونىت ماتېرىيالى',
    jcxx:'ئاساسىي ئۇچۇرلار',
    tx:'باش سۈرەت',
    sczp:'رەسىم چىقىرىش',
    tudxxz:'چىقارماقچى بولغان رەسىمنى تاللاڭ： رەسىمنىڭ چوڭ كىچىكلىكى 413*626، jpg png رەسىم شەكلىنى قوللايدۇ، رەسىم 2m دىن كىچىك بولىشى كېرەك',
    gjhdq:'دۆلەت ۋە رايون',
    dzyx:'ئېلىكتىرونلۇق ئىلخەت',
    bcxg:'ئۆزگەرتكەننى مۇقۇملاشتۇرۇش',
    zhaq:'ھېسابات نومۇرى بېخەتەرلىكى',
    dqmm:'ھازىرقى مەخپى نومۇر',
    xmm:'يېڭى مەخپى نومۇر',
    qrmm:'مەخپى نومۇرنى مۇقۇملاش',
    qsrdqmm:'ھازىرقى مەخپى نومۇرنى كىرگۈزۈڭ',
    qd:'مۇقۇملاشتۇرۇش',
    tjtb:'ماس قەدەملىك مەشغۇلاتنى قوشۇش',
    tb:'ماس قەدەم',
    xh:'سېگنال',
    qsrnr:'مەزمۇننى كىرگۈزۈڭ',
    tbzh:'ماس قەدەملىك ھېسابات نومۇرى',
    qxztbzh:'ماس قەدەملىك ھېسابات نومۇرىنى تاللاڭ （كۆپ تاللىسىڭىزمۇ بولىدۇ）',
    jygz:'سودا قانۇنىيىتى',
    bzjdb:'كاپالەت پۇلى تەڭ نىسبىتى',
    jzdb:'ساپ قىممەت تەڭ نىسبىتى',
    kyzjdb:'ئىشلەتكىكى بولىدىغان مەبلەغ',
    jyldb:'ھېسابات مىقدارى تەڭ نىسبىتى',
    gdssdb:'مۇقىم سان تەڭ نىسبىتى',
    jycs:'سودا پارامېتىرى',
    kcjybc:'开仓价优补偿',
    xhsxzdpc:'信号失效自动平仓',
    zdss:'最大手数',
    zdhc:'最大回撤',
    jsbz:'خەلقئارا ئۆلچەملىك توختامنى ھېسابلاش ئۆلچىمى قىلىدۇ (پۇلنىڭ خەلقئارا ئۆلچەم بىلەن بولغان كېلىشىمى 100000 ؛ ئالتۇن بىلەن بولغان خەلقئارا ئۆلچەم كېلىشىمى 100 ئۇنسىيە ؛ كۈمۈش بىلەن بولغان خەلقئارا ئۆلچەم كېلىشىمى 5000 ئۇنسىيە ؛ نېفىت بىلەن بولغان خەلقئارا ئۆلچەم كېلىشىمى (تەخمىنەن 1000 تۇڭ) 约1000桶)',
    pctbts:'بىر قىسىم ئامبار تەڭشەش ۋە تەڭپۇڭلاشتۇرۇش مەشغۇلاتىنىڭ ئوخشاش بولمىغان سۇپا، تېرمىناللاردا ئېلىپ بېرىلىدىغان مەشغۇلات قائىدىسى ئوخشاش بولماسلىقىغا ئاساسەن، ماس قەدەملىك جەريانى ۋاقتىنچە قوللىنىشقا بولمايدۇ',
    tbxh:'ماس قەدەملىق سېگىنال',
    tbms:'ماس قەدەملىك ئەندىـزە',
    tbxs:'ماس قەدەملىك كوئېففېتسېنت',
    tbsz:'ماس قەدەملىك تەڭشەش',
    xgcs:'پارامېتىرنى ئۆزگەرتىش.',
    yzttb:'ماس قەدەمنى توختىتىش',
    ykqtb:'ماس قەدەمنى ئېچىش',
    sctb:'ماس قەدەمنى يۇيىۋىتىش',
    xgtbcs:'ماس قەدەم پارامېتىرنى ئۆزگەرتىش.',
    cgtbzt:'ماس قەدەملىك ھالەتنى ئۆزگەرتىش',
    sfqkzhdtb:'نۆۋەتتىكى ھېسابات نومۇرى **** نىڭ ماس قەدەملىك مەشغۇلاتىنى ئاچامسىز',
    sfztzhdtb:'نۆۋەتتىكى ھېسابات نومۇرى **** نىڭ ماس قەدەملىك مەشغۇلاتىنى ئىتىۋىتەمسىز',
    tjxh:'سېگىنالنى قوشۇش',
    nsyl:'يىللىق كىرىم نىسپىتى',
    zt:'ھالەت',
    dyz:'ماس قەدەم ئالغۇچى',
    kstbsj:'ماس قەدەملىك ھالەتنى ئاچقان ۋاقىت',
    zwsj:'ھازىرچە سانلىق مەلۇمات يوق',
    xzzh:'ھېسابات نومۇرىنى تاللاش',
    qxzzh:'ھېسابات نومۇرىنى تاللاڭ',
    qqdxhhtbzzt:'ماس قەدەمنى ئىشلەتكۈچى بىلەن سېگىنالىڭىزنى سېلىشتۇرۇپ، چەكسىز ئايلىنىش خەتىرىنىڭ كۆرۈلۈشىنىڭ ئالدىنى ئېلىڭ',
    xhm:'سېگىنال ئىسمى',
    qsrxhm:'سېگىنال ئىسمىنى كىرگۈزۈڭ （ئەڭ كۆپ بولغاندا 15 خەت ۋە ھەرىپ بولىشى كېرەك）',
    xhmts:'سېگىنال ئىسمى: بىر ھېسابات نومۇرى بىر سېگىنال ئىسمىغا توغرا كېلىدۇ، مۇقۇملاشتۇرغاندىن كېيىن ئۆزگەرتكىلى بولمايدۇ',
    gszzdjz:'ئەگەشكۈچىنىڭ ئەڭ تۆۋەن ساپ قىممىتى',
    sfgkxh:'سېگىنالنى ئاشكارلامسىز',
    gk:'ئاشكارلايمەن',
    sm:'مەخپى قىلىمەن',
    gsddzs:'تالونغا ئەگىشىش',
    gsddzsts:'بۇ يەرگە توشقۇزغان مەزمۇنلار بارلىق ئەگەشكۈچىلەرنىڭ mt تالونى خاتىرلەش رايونىدا كۆرۈنىدۇ',
    jdzyjgyhkf:'كەسپى/ئاپرات ئابونىتلىرىغىلا ئېچىۋىتىلىدۇ',
    xhms:'سېگىنال تونۇشتۇرۇلۇشى',
    sl:'مىسالبۇ ھېسابات ئىگىسى قىسقا لىنىيە قىلىپ ، كۈن ئىچىدە يەككە يەككە پايدا-زىياننى توختىتىدۇ ، 2000 ئامېرىكا دوللىرىنىڭ سانى 1: 1 ماس قەدەملىك بولۇشنى تالىشىڭىزنى تەۋسىيە قىلمىز：',
    clmsts:'بارلىق ئابونىتلارنىڭ شەخسىي ئۇچۇرىنى قوغداش ئۈچۈن ، تاكتىكا چۈشەندۈرۈلىشى ئىچىدە ئالاقىلىشىش ئۇسۇلى بار بولغان ھەر قانداق ئۇچۇرنىڭ بولىشىغا يول قويۇلمايدۇ',
    xhlb:'سېگىنال تەرتىپى',
    xhlbts:'بەت سانلىق مەلۇماتى سېگىنال مەنبەسى بولغان ئۈچۈنچى تەرەپتىن قوبۇل قىلىنىدىغان بولۇپ، سانلىق مەلۇماتلارنى ئىستاستىكا قىلىش جەريانىدا كېچىكىش ياكى ئېنىقسىزلىق بولسا، سانلىق مەلۇماتلارنى پەقەت پايدىلىنىش ئۈچۈن قوللانسا بولىدۇ لىكىن ئەمەلىي پايدا ئېلىشقا ئىشلىتىشكە بولمايدۇ',
    xhy:'سېگىنال مەنبەسى',
    zongsyl:'ئۇمۇمىي پايدا نىسبىتى',
    zhousyl:'ھەپتىلىك پايدا نىسبىتى',
    jqtjycs:'يېقىنقى يەتتە كۈنلۈك سودا قېتىم سانى',
    irrqzsy:'irr پايدىسى',
    zdhc2:'ئەڭ چوڭ قايتقان پۇل（%）',
    zq:'بىر دەۋىر （كۈن）',
    jbsj:'ئاساسلىق سانلىق مەلۇمات',
    fx:'ھەمبەھىرلەش',
    sc:'ساقلاش',
    ysc:'ساقلىنىپ بولدى',
    zsy:'ئومۇمىي پايدا',
    zrj:'ئومۇمىي سېلىنغان پۇل',
    zcj:'ئومۇمىي چىقىم',
    zdhcl:'ئەڭ چوڭ قايتىش نىسبىتى （%）',
    zdfk:'ئەڭ چوڭ ئايلانما پۇل',
    zdds:'ئومۇمىي تالون سانى',
    dbzdjyl:'بىر قېتىملىق ئەڭ چوڭ سودا مىقدارى',
    t:'كۇن',
    zhhbdw:'ھېسابات نومۇرىنىڭ پۇل بىرلىكى',
    ckqb:'ھەممىنى كۆرۈش',
    anyue:'ئايلىق',
    jidu:'بىر پەسىل',
    bannian:'يېرىم يىل',
    yinian:'بىر يىل',
    ernian:'ئىككى يىل',
    sanian:'ئۈچ يىل',
    jzye:'ساپ قىممەت /قالدۇق （$）',
    crj:'كىرىم-چىقىم （$）',
    cj:'چىقىم',
    rj:'كىرىم',
    ysyl:'ئايلىق پايدا نىسبىتى',
    yiyue:'1-ئاي',
    eryue:'2-ئاي',
    sanyue:'3-ئاي',
    siyue:'4-ئاي',
    wuyue:'5-ئاي',
    liuyue:'6-ئاي',
    qiyue:'7-ئاي',
    bayue:'8-ئاي',
    jiuyue:'9-ئاي',
    shiyue:'10-ئاي',
    shiyiyue:'11-ئاي',
    shieryue:'12-ئاي',
    ccxj:'ئامبار ئىنچىكە نۇقتىللىرى',
    cq:'مەھسۇلات',
    dk:'كۆپ/بوش',
    ss:'سان',
    yk2:'پايدا/زىيان',
    hlzb:'ئۆلچەش كۆرسەتكۈچى',
    ylddcxsjpj:'پايدا تالونىنىڭ داۋاملاشقان ۋاقتى',
    ksddcxsjpj:'زىيان تولونىنىڭ داۋاملاشقان ۋاقتى',
    dgddylpj:'بىر تالوننىڭ تاق پايدىسى ',
    dgddkspj:'بىر تالوننىڭ تاق زىيىنى ',
    dgddlrzd:'بىر تالوننىڭ تاق پايدىسى ',
    dgddkszd:'بىر تالوننىڭ تاق زىيىنى',
    syl:'پايدا نىسبىتى',
    sjbl:'سانلىق مەلۇمات نىسبىتى',
    sl:'پايدا نىسبىتى',
    zdjybl:'ئاپتۇماتىك سودا نىسبىتى',
    pcddmx:'ئامبار زاكاز تالونى تەپسىلاتى.',
    pcjg:'平仓价格',
    sxf:'مەشغۇلات ھەققى',
    tbxtccsc:'ماس قەدەملىك سېستىمىنىڭ مەشغۇلات قوللانمىسى',
    zhzc:'ھېسابات نومۇرىنى ئەنگە ئېلىش',
    xtdl:'سېستىمىنى ئېچىش',
    jzhszwxh:'ھېسابات نومۇرىنى سېگىنالغا ئۆزگەرتىش',
    sztbxh:'ماس قەدەملىك سېگىنالغا تەڭشەش', 
    wzjs:"JCLH بولسا تېرمىنال ئابونتلىرىغا توپلانغان سانلىق مەلۇماتلارنى تەمىنلەش ۋە ئۇلارنى ئۇچۇرلاردىن تەڭ بەھرىمەن قىلىدىغان باشقۇرۇش سۇپىسى. ئابونىتلار JCLH ئارقىلىق باشقۇرۇش، تەھلىل قىلىش ۋە ھېسابات نومۇرى  مالىيەسىنى ۋە خەۋپ - خەتىرىنى جەملەش مەشغۇلاتنى ئېلىپ بارسا بولىدۇ. JCLH ماس قەدەملىك سىستېمىسى ئوبونېتلارنى كۆپ خىل ھېسابات نومۇرىنى باشقۇرۇش ئوتتۇرىسىدىكى ماس قەدەملىك مۇناسىۋەت بىلەن تەمىنلەيدۇ. JCLH بىر سودا سۇپىسى سودىگىرى ئەمەس ھەمدە ھەرقانداق پۇل مۇئامىلە ئاپپاراتى بىلەن مەنپەئەت، تونۇشتۇرۇش، ئارىچىلىق مۇناسىۋىتى يوق.",
    mzsmText:`<p dir="RTL" style="text-align: center;  direction: rtl; unicode-bidi: embed; line-height: normal;">
    <span style="color: rgb(255, 255, 255);"><span style="line-height: 150%; font-family: &quot;ALKATIP Basma Tom&quot;; font-size: 22px;">جاۋابكارلىقتىن كەچۈرۈم قىلىش باياناتى</span></span>
</p>
<p dir="RTL" style="text-align: justify;  direction: rtl; unicode-bidi: embed; line-height: normal;">
    <span style="font-size: 12px; line-height: 150%; font-family: &quot;ALKATIP Basma Tom&quot;; color: rgb(255, 255, 255);">بۇ باياناتنى JCLH بىلەن www.JCLH.biz تور بىكتىدە ئەنگە ئېلىپ، تىزىملاتقان ھەمدە بۇ ماددا ۋە شەرتلەرنى ئېنىق قوبۇل قىلغان شەخس ياكى شىركەت بىرلىكتە ئىمزالىغان.</span>
</p>
<p dir="RTL" style="text-align: justify;  direction: rtl; unicode-bidi: embed; line-height: normal;">
    <span style="font-size: 12px; line-height: 150%; font-family: &quot;ALKATIP Basma Tom&quot;; color: rgb(255, 255, 255);"> تور بېكىتىمىز ئېھتىياتچانلىق بىلەن تەدبىر قوللىنىپ، ئۇچۇرلارنى تەكشۈرۈپ ئېنىقلىدى، لېكىن ئۆز ئىچىگە ئالغان ئۇچۇرلارنىڭ ھەممىسىنىڭ پۈتۈنلەي توغرا بولۇشىغا كاپالەتلىك قىلالمايمىز. بىزنىڭ ئۇچۇرلىرىمىزنىڭ پۈتۈنلەي تولۇق بولماسلىقىنى، ياكى بىر قىسىم ئۇچۇرلارنىڭ چۈشۈپ قالغان بولىشىنى توغرا چۈشىنىشىڭىزنى ئۈمىد قىلىمىز. تور بېكىتىمىز ياكى مۇستەقىل ئۇچۇر تەمىنلىگۈچىلەر ئۇچۇرلارنىڭ خاتا بولۇپ قېلىشى، مۇكەممەل بولماسلىقى، كېچىكىپ ئېلان قىلىنىشى، دەل جايىدا بولماسلىقى ياكى تور بېكىتىمىزنىڭ ئۇچۇرىغا تايىنىش سەۋەبىدىن كېلىپ چىققان زىياننىڭ مەسئۇلىيىتى ئۆز ئۈستىگە ئالمايدۇ. بارلىق ئالدىن مۆلچەر ياكى كۆز قاراشلار (كەلگۈسىدىكى پېرېۋوت نىسبىتىنىڭ ئۆزگىرىشىنى بولغان ئالدىن مۆلچەر) ۋە مۇشۇ ئالدىن مۆلچەرلەر ئاساسىدا ئېلىپ بېرىلىدىغان سودا پائالىيەتلىرى پەقەت ئۈچىنچى تەرەپنىڭ شەخسىي كۆز قارىشى ۋە ھەرىكىتىگە ۋەكىللىك قىلىدىغان بولۇپ، تور بېكىتىمىزنىڭ كۆز قاراش، مەيدانىغا ۋەكىللىك قىلمايدۇ. سىز چوقۇم ئۈچىنچى تەرەپنىڭ ئالدىن مۆلچەرىنىڭ ھەر قانداق شەكىلدىكى كەسىپ نەتىجىسى ۋەدىسىدىن دېرەك بەرمەيدىغانلىقىنى چۈشىنىشىڭىز كېرەك شۇڭا بىۋاسىتە ياكى ۋاسىتىلىك شەكىلدە دورىسىڭىز ياكى تەقلىد قىلسىڭىز بولمايدۇ. سىز چوقۇم مۇستەقىل تەھلىل قىلىپ مەبلەغ سېلىش ھۆكۈمى چىقىرىشىڭىز كېرەك، شۇنىڭ بىلەن بىر ۋاقىتتا، تور بېكەتىمىزنىڭ مەزمۇنىغا ئاساسەن ھۆكۈم قىلىش ئارقىلىق ئېلىپ بېرىلغان مەبلەغ سېلىش ھەرىكىتىدە ئەمەلىي پايدا ياكى زىيان كېلىپ چىقىشى مۇمكىن ئىكەنلىكىنىمۇ ياخشى چۈشىنىشىڭىز كېرەك. سىز تور بېكىتىمىز تەمىنلىگەن سودا تاكتىكىسى ۋە سىگنالىنى ئاساس قىلىپ، شەخسىي سەپلىمە سودا سىستېمىسىدىن پايدىلىنىپ قىلغان مەبلەغ سېلىش ھەرىكىتى ئۆزىڭىز قارار قىلغان نەتىجە بولۇپ ھېساپلىنىپ، بارلىق خەۋپ-خەتەرنى ئۆزىڭىز ئۆزى ئۈستىگىزگە ئېلىشىڭىز كېرەك.</span>
</p>
<p dir="RTL" style="text-align: justify;  direction: rtl; unicode-bidi: embed; line-height: normal;">
    <span style="line-height: 150%; font-family: &quot;ALKATIP Basma Tom&quot;; font-size: 12px; color: rgb(255, 255, 255);">تور بېكىتىمىز شۇنى ئېنىق چۈشۈندۈرىدىكى، تور بېكەتنىڭ باشقۇرۇش سۇپىسى پەقەت خەتىرى يۇقىرى بولغان مەبلەغ سېلىشقا نىسبەتەن بەلگىلىك چۈشەنچىگە ئىگە بولغان ئابونېتلارغا ماس كېلىدۇ. سىز كۈندىلىك تۇرمۇشىڭىزغا تەسىر يەتكۈزمەسلىك ئاساسىدا يېنىڭىزدىكى ئېشىنچە مەبلەغنى ئىشلىتىپ چىقىم قىلىپ مەبلەغ سالسىڭىز بولىدۇ. ھەرقانداق سودا تاكتىكىسىنىڭ ئىلگىرى قولغا كەلتۈرگەن نەتىجىلىرى ئۇنىڭ كەلگۈسىدىكى ئۈنىمىگە، ئىپادىسىگە ۋەكىللىك قىلالمايدۇ. ئادەتتە كەلگۈسىدىكى پېرېۋوت نىسبىتىنىڭ ئۆزگىرىشىنى ئالدىن مۆلچەرلىگىلى بولمايدۇ، بۇ شەخسىي تاكتىكا، پۇل مۇئامىلە مەسلىھەتى، يۈزتۇرانە ياكى ئاپتوماتىك ھالدا ئېلىپ بېرىلىدىغان سودا سىستېمىسى قاتارلىقلارنىڭ ھەر قانداق شەكىلدىكى ئالدىن مۆلچەرنىڭ پايدا ھاسىل قىلىش مۇمكىنچىلىكىگە كاپالەتلىك قىلالمايدىغانلىقىنى بىلدۈرىدۇ. شۇڭا مەبلەغ سېلىش ئالدىن مۆلچەرىگە قارىتا چوقۇم ئۆزىنىڭ تەھلىلى ئارقىلىق ھۆكۈم چىقىرىش، قارىغۇلارچە ئەگىشىشتىن قاتتىق ساقلىنىش كېرەك.</span>
</p>
<p dir="RTL" style="text-align: justify;  direction: rtl; unicode-bidi: embed; line-height: normal;">
    <span style="line-height: 150%; font-family: &quot;ALKATIP Basma Tom&quot;; font-size: 12px; color: rgb(255, 255, 255);"> تور بېكەتكە ساقلاش ياكى توردا يوللاش جەريانىدا كېچىكىش كۆرۈلۈش سەۋەبىدىن سانلىق مەلۇماتلاردا خاتالىق پەرقى كېلىپ چىقىشى مۇمكىن (سىگنال بىلەن تەمىنلىگەن ھېسابات نومۇرىنىڭ مەخپىي نومۇرنى ئۆزگەرتىش ياكى باشقا تور سەۋەبىدىن كېلىپ چىققان ھېسابات ئۈزۈلۈپ قېلىپ تالوننىڭ ئەگىشىش مۇناسىۋەتىنىڭ يوقاپ كېتىشىنى ئۆز ئىچىگە ئالىدۇ لېكىن چەكلەنمەيدۇ). شۇڭا، ئىشلەتكۈچىلەر ماس قەدەملىك سىستېمىنى ئىشلەتكەندىن كېيىن، كۆپ ھېسابات نومۇرىنى باشقۇرۇش سىستېمىسىدىكى سانلىق مەلۇماتلارنىڭ ئۆزگىرىشىنى ۋاقتىدا تەكشۈرۈپ تۇرىشى كېرەك. مەيلى JCLH بولسۇن ياكى تور بېكىتىمىزدىكى ھەرقانداق ھەمكارلاشقۇچىسى بولسۇن سىز JCLH گە ئاساسلىنىپ تەمىنلىگەن ئۇچۇرنىڭ توغرىلىقىغا ۋە شەخسىي سەپلىمە ماس قەدەملىك سىستېمىسى ئارقىلىق مەبلەغ سالسىڭىز چوقۇم پايدا ئالىدىغانلىقىڭىزغا كاپالەتلىك قىلالمايدۇ.</span>
</p>
<p dir="RTL" style="text-align: justify;  direction: rtl; unicode-bidi: embed; line-height: normal;">
    <span style="line-height: 150%; font-family: &quot;ALKATIP Basma Tom&quot;; font-size: 12px; color: rgb(255, 255, 255);"> ئۇنىڭدىن باشقا يەنە، JCLH ماس قەدەملىك سىستېمىنىڭ ئاچقۇچىسى بولۇش سۈپىتى بىلەن، ئۈچىنچى تەرەپ (مەسىلەن، بۇ خىل مۇلازىمەت بىلەن تەمىنلىگۈچى شىركەت ياكى سودىلاشقان تېجارەتچى) نىڭ كېچىكتۈرۈپ قويۇشى، بىخەستىلىك قىلىشى سەۋەبىدىن كېلىپ چىققان زىيان ئۈچۈن جاۋابكارلىقنى ئۈستىگە ئالمايدۇ. يۇقىرىقىلاردىن باشقا، JCLH سودا خادىملىرى تەمىنلىگەن تاكتىكا ۋە سودا سىگنالى ئۈچۈن ھېچقانداق مەسئۇلىيەتنى ئۈستىگە ئالمايدىغانلىقىنى ئېنىق بىلدۈردى.</span>
</p>
<p dir="RTL" style="text-align: justify;  direction: rtl; unicode-bidi: embed; line-height: normal;">
    <span style="line-height: 150%; font-family: &quot;ALKATIP Basma Tom&quot;; font-size: 12px; color: rgb(255, 255, 255);"> قانۇندا باشقا باشقۇرۇش قانۇنلىرىنى ئىشلىتىش بەلگىلەنمىگەن بولسىلا، JCLH تەۋە شىركەتنى ئەنگە ئالدۇرغان جايدىكى قانۇن، نىزاملار مەزكۇر باياناتنى قوللىنىش ئارقىلىق باياناتنىڭ ھەرقايسى تەرەپلىرىنى باشقۇرۇش ئوتتۇرىسىدا كېلىپ چىققان تالاش - تارتىشلارنى ھەل قىلىدۇ.</span>
</p>
<p dir="RTL" style="text-align: justify;  direction: rtl; unicode-bidi: embed; line-height: normal;">
    <span style="line-height: 150%; font-family: &quot;ALKATIP Basma Tom&quot;; font-size: 12px; color: rgb(255, 255, 255);"> توختاملاشقان بىر تەرەپ بۇ باياناتتىكى ھوقۇقىنى ئەمەلگە ئاشۇرۇشنى تەلەپ قىلغان ياكى بۇ باياناتتىكى ھەرقانداق ھوقۇق ياكى مەجبۇرىيىتىنى جاكارلاشنى تەلەپ قىلغان ھەرقانداق ھەق تەلەپ دەۋاسى ياكى باشقا دەۋا جەريانىدا، ھەر قايسى توختام تۈزۈشكۈچى تەرەپ ۋاكالەتچى ئادۋوكاتنىڭ خىراجىتى ۋە چىقىمىنى ئۆز ئۈستىگە ئېلىشى كېرەك. توختام تۈزۈشكۈچى تەرەپ مەخسۇس باشقۇرۇش تەۋەلىكى ۋە سوت ئاچىدىغان سوت مەھكىمىسىنى ئېتراپ قىلغان بولىشى كېرەك.</span>
</p>
<p dir="RTL" style="text-align: justify;  direction: rtl; unicode-bidi: embed; line-height: normal;">
    <span style="line-height: 150%; font-family: &quot;ALKATIP Basma Tom&quot;; font-size: 12px; color: rgb(255, 255, 255);"> </span>
</p>
<p dir="RTL" style="text-align: right;  direction: rtl; unicode-bidi: embed; line-height: normal;">
    <span style="font-size: 12px; color: rgb(255, 255, 255);"> <span style="color: rgb(255, 255, 255); font-size: 12px; line-height: 150%; font-family: &quot;ALKATIP Basma Tom&quot;;">بۇ باياناتنىڭ چۈشەندۈرۈلۈشى خەنزۇ تىلىدا بولۇپ، ئەگەرخەنزۇ تىلى يېزىقىدا يېزىلمىغان ھەر قانداق ھۆججەت، ئۇچۇر ۋە خەۋەرنىڭ بايانى بىلەن بولغان پەرىق سەۋەبىدىن زىددىيەت ۋە ئوخشىماسلىق كۆرۈلسە، ئىككى تەرەپ خەنزۇ تىلىدا يېزىلغان ھۆججەت ۋە ئۇچۇرلارنى ئۆلچەم قىلىشى كېرەك.</span></span>
</p>
<p style="line-height: normal;">
    <span style="font-size: 12px; color: rgb(255, 255, 255);"></span>
</p>
<p>
    <br/><br/>
</p>`,
    yszcText:`<p style="font-weight: bold; color: windowtext; text-align: center; ">
    <strong>
        <span style="color: #ffffff; font-family: 微软雅黑; font-size: 22px;">
            隐私政策
        </span>
    </strong>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">感谢您使用 JCLH ！</span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        本《隐私政策》说明了我们如何收集、使用、处理和披露您的信息,包括与您访问和使用 JCLH 的个人信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        如果本《隐私政策》中有未定义的术语（如“服务项目”或“ JCLH ”），其定义和我们在服务条款中的定义一致。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        在本政策中，“ JCLH ”、“我们”或“我们的”指本《隐私政策》下对您的信息负责的 JCLH 公司。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1. 我们收集的信息类型
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        我们主要收集三类信息。
    </span>
</p>

<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        1.1 您向我们提供的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        使用 JCLH 的必要信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        当您使用 JCLH 时，我们要求您提供并收集以下您的个人信息。此等信息对于充分履行您和我们之间的合同很有必要，并使得我们能够遵守我们的法律义务。没有此等信息，我们可能无法向您提供您所要求的全部服务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.1.1 账号信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        在您注册 JCLH 账号时，我们要求您提供用户昵称、手机号码、电子邮件地址、密码、头像等信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.1.2 您选择向我们提供的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以选择向我们提供额外的个人信息，以便在使用 JCLH 时获得更好的用户体验。此等额外信息将基于您的自愿同意而处理。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        额外个人资料信息。您可选择提供额外个人资料信息，作为您个人资料的一部分（例如首选语言、国家和地区及个人描述）。如您在账号设置中所示，部分此等个人信息是您公开个人资料页的一部分，将向其他人公开。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        交易风控信息。您可选择提供设置账户交易时使用的风控策略。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        其他信息。您还可以选择在填写表格、进行搜索、更新或添加 JCLH 账号信息或使用 JCLH 的其他功能时，向我们提供其他信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.2 您使用 JCLH 时，我们自动收集的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        在您使用 JCLH 时，我们会自动收集关于您所使用的服务以及如何使用相关服务的信息，包括个人信息。 基于我们合法的利益理由以提供和改进 JCLH ，此等信息对于充分履行您和我们之间的合同很有必要，使得我们能够遵守法律义务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        登录数据和设备信息。即使您未创建或登录 JCLH 账号，当您访问并使用 JCLH 时，我们也会自动收集登录数据和设备信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        Cookies 及类似技术。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        Log-In Cookies : 当您使用“在此计算机自动登录”的功能时，我们会使用持久 Cookies 。在这种情况下， Cookies 文件将永久的保存在您的计算机硬盘上，除非您使用浏览器或操作系统软件手工将其删除。当您再次使用该网站时，网站就会通过读取这些 Cookies，得知您的相关信息，就可以做出自动登录的动作。这些 Cookies 包含一个 ID 号。您的登录资料和您的密码不会被保存。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.3 我们通过第三方收集的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        第三方平台的交易账户信息。如果您将第三方交易账户连接至 JCLH，您将授权 JCLH 获取您的第三方平台的交易账户相关信息（比如：交易商信息、账户名、只读密码、交易数据等）。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        2.我们如何使用所收集的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        我们使用、存储和处理您的信息（包括个人信息），以提供、了解、改进和发展 JCLH ，创建和维护一个受到信任的、更安全的环境，并遵守我们的法律义务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        2.1 创建和维护一个受到信任的以及更安全的环境
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        检测和预防欺诈、滥用、安全事件及其他有害活动。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        开展安全调查和风险评估。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        对照数据库与其他信息源进行检查，包括在适用法律允许的限度内以及必要时经您同意进行背景或警方调查。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        遵守我们的法律义务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        解决我们与任何会员之间的任何争议，并执行我们与第三方的约定。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        执行我们的服务条款及其他政策。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.分享与披露
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.1 征得您的同意
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        经您同意，我们可以按照您在同意时的指示分享您的信息（包括个人信息），如当您授权第三方应用软件或网站访问您的 JCLH 账号时。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.2 业务转移
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        如果 JCLH 从事或涉及任何合并、收购、重组、资产出售、破产或者资不抵债的事件，那么我们可以出售、转让或分享我们的部分或全部资产，包括与此类交易或设想的此类交易(如尽职调查)有关的您的信息。在此情况下，我们会在转移您的个人信息且令其遵守不同隐私政策之前通知您。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.3汇总信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        出于遵守法规、行业与市场分析、受众统计归类、营销与广告以及其他业务目的，我们也会分享汇总信息（关于我们用户的合并信息，此类信息不再识别或指向某位个人用户）和其他匿名信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        4.其他重要信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        4.1 关联第三方账号
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您通过关联账号向我们提供的一些信息可能会被存储、处理和传输，用于欺诈防范和风险评估；以及对于您通过此类链接向 JCLH 提供的信息，其发布与显示取决于您在 JCLH 和第三方网站上的设置与授权。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.您的权利
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以联系我们，在相关 JCLH 数据控制人适用之前行使本条所述的任何权利。请注意，在对您的请求采取进一步行动之前，我们可能会要求您验证您的身份。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.1 管理您的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以通过您的账号设置访问和更新您的一些信息。您有责任及时更新您的个人信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.2 不准确或不完整的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您有权要求我们更正您的不准确或不完整的个人信息（以及您无法在您的 JCLH 账号中自行更新的信息）。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.4 数据保留与删除
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以向官方客服申请注销帐号或删除账户信息,工作人员会在3个工作日内处理。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        通常，我们只在履行您与我们之间的合同并遵守我们的法律义务的必要时间段内保留您的个人信息。如果您不再希望我们使用您的信息来为您提供 JCLH ，您可以要求我们删除您的个人信息并关闭您的 JCLH 账号。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        请注意，如果您申请删除您的个人信息：
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        我们可能会保留您的一些个人信息，以符合我们的合法商业利益，如欺诈侦测和预防以及提高安全性。例如，如果我们因欺诈或安全原因停用了 JCLH 账号，则我们可能会保留该 JCLH 账号的某些信息，以防止该会员将来再次创建新的 JCLH 账号。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        为了遵守我们的法律义务，我们可能会保留并使用您的个人信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        即使您的 JCLH 账号被注销，您与他人分享的信息仍可以在 JCLH 上公开显示。但您对这些信息的归属信息将被删除。此外，您的信息的某些副本（如登录记录）可能会保留在我们的数据库中，但会与个人标识符区分开来。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        6. 全球运营
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        为方便我们的全球运营， JCLH 可在我们的公司内部或与服务提供商转移、存储和处理您的信息。这些国家/地区的法律或许与您居住地所适用的法律不同。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        7.安全
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        我们将持续实施和更新管理、技术和物理安全措施，保护您的信息不受未经授权的访问、损失、破坏或变更。我们用来保护您的信息的一些安全措施是防火墙和数据加密以及信息访问控制。如果您知道或有理由相信您的 JCLH 账号信息已丢失、被盗用、被挪用或遭到其他方式入侵，或者出现任何实际或怀疑盗用您的 JCLH 账号的情况，请按照以下“联系我们”一条的说明联系我们。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        8.本《隐私政策》的变更
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        JCLH 保留随时根据本条规定修改本《隐私政策》的权利。如果我们对本《隐私政策》做出变更，我们将在 JCLH 上发布变更后的《隐私政策》，并更新《隐私政策》顶端的“最后更新”日期。如果您不同意变更后的《隐私政策》，您可以注销您的账号。如果您未在变更后的《隐私政策》生效前注销您的账号，您对 JCLH 的继续访问或使用将受变更后的《隐私政策》的约束。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        9.联系我们
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        如果您对本《隐私政策》或 JCLH 的信息处理方法有任何问题或意见，您可以通过官网在线客服与我们联系，或通过 JCLH 官方提供的各种联系方式与我们联系， JCLH 将给予您帮助。
    </span>
</p>
`,
fwtkText:`<h1 style="text-align: center; line-height: normal; text-indent: 0em;">
<span style="font-size: 22px;"><strong><span style="color: rgb(255, 255, 255); font-family: 微软雅黑;">服务条款</span></strong></span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;"><span>欢迎您使用</span> JCLH 网站的服务。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您应当阅读并遵守《 JCLH 服务条款》(以下简称“本协议”)，请您务必审慎阅读、充分理解各项条款内容。除非您已充分阅读、完全理解并接受本所有条款内容，否则您无权使用 JCLH 服务。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">本协议是由 JCLH 与在网站 www.JCLH.biz 上的已注册登记并已明确接受此等条款和条件的个人或公司共同签署。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统可以让您实现在云端管理多平台。用户可以通过JCLH管理、分析和汇总账户财务和风险。系统允许用户通过“Copy-Trading”的方式进行跨平台订单复制。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH不是不是经纪商或交易商，也不与任何金融机构有利益、介绍或居间关系。公司专注服务被传统金融市场忽略的一大部分客户：中小企业，个人客户。我们通过技术，让资产集合、风险管理、多账户管理、策略开发成为容易上手的业务。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">风险协议</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.考虑到交易存在巨大的风险，建议您在开户及交易前充分了解相关法律条规及咨询专业意见，根据个人的财务状况、投资经验、风险偏好等相关因素，慎重选择适合您的保证金交易产品。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 网站上所有信息（含文字、图片、音频、视频）均出于为公众传播有益资讯信息之目的，并不意味着 JCLH 赞同其观点或构成投资建议，且 JCLH 不会向您提供任何可依赖的投资建议。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.投资市场存在的风险是不受 JCLH 控制或影响的，您所有的交易均由个人承担风险。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">业绩统计服务</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您应当理解，实际投资交易的收益/亏损百分比会随着各项因素而发生变化，如初始账户余额、市场行为、跟随者的账户设置等。因此，您在进行投资过程中实际产生的收益/亏损百分比可能与JCLH 多账户管理平台中信号提供者收益/亏损百分比存在一定的差异。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 不保证您所使用的信号提供者信号或本网站所传播的信息能让您获得利润而不亏损，您在 JCLH 多账户管理平台上进行保证金投资的实际收益/亏损均由您本人承担， JCLH 不承担任何相关责任。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">网上风险服务</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您理解并同意，使用互联网的交易服务存在一些风险，包括硬件、软件或互联网连接等不可控因素，如信号强度、互联网的接收或路径、设备硬件或软件配置、或互联网连接的可靠性等不可控。 JCLH 不对网络交易中出现的通讯故障、误传或延误造成的损失负任何责任。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.贵金属等全球金融产品投资市场的波动性或非流动性可能阻碍委托以有利的价格执行，或根本无法执行。如因市场情况或您的交易商的过错而导致交易无法执行，从而造成的任何损失、损害、成本或费用</span>(<span>包括但不限于，利润损失、使用损失、直接、间接、偶发或结果性损害</span>)<span>，</span> JCLH <span>不承担任何责任。</span></span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">外部链接服务</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您理解并同意，通过 JCLH 网站链接到其他某些网站仅出于便利而提供。因这些网站所含的信息资料不可控制， JCLH 不对这些网站或您在这些网站找到的资料作出任何承诺。 JCLH 通往这些网站的链接信息，并不构成任何类型的认可或建议。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">适用法律和管辖权</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.JCLH所属公司注册所在地法律、法规应适用于本协议以及管辖本协议各方之间引起的争议，除非存在法律指定适用其他管辖法律。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.在合约一方寻求实现本协议下的权利，或寻求宣告本协议下的任何权利或义务的任何民事诉讼或其他诉讼过程中，各合约方应承担其代理律师的费用和支出。合约方认可专属管辖和法院审判地。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.本协议的解释语言应为（简体）中文。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">4.如果任何文件、信息和消息的非中文表述和中文表述之间出现矛盾和不一致的情况下，双方将以中文文件、信息和消息为标准。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">其他</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">如果您对本条款有意见或建议，可与 JCLH 客服联系， JCLH 将给予您帮助。</span>
</p>
<p>
<br/>
</p>`,
    mzsmbt:"جاۋابكارلىقتىن كەچۈرۈم قىلىش باياناتى",
	mzsmbt:"چۈشەندۈرۈش بىلەن",
	qwzxcz:"ھەسابنى قاچىلىغان كەسپىتى تەمىنلەش ئۈچۈن، ئۆزىڭىز ئۇچرۇنما قىلىشىڭىزنى مەنئە قىلىڭ!",
	wdzl:"مەنىڭ مەلۇماتلىرىم",
	wdqb:"مەنىڭ قاپىتىم",
	hyfw:"ئەھۋالدىن چىقىش",
	wdtd:"مەنىڭ تىمىم",
	tcdl:"ھۆدەلەش مەنAGERلىك",
	xhgl:"جىنايە قائىدەلەرى: پۇللار ۋە سىگنال پۇللارنى 1:1 ئەساسىnda قىيمە تەييارلاش بەلگىسى; ئەھۋالدىن چىقىش",
	sfgz:"ئۇسۇللۇق ئەھۋالدىن چىقىش: پۇللار ۋە سىگنال پۇللارنى 1:1 ئەساسىnda قىيمە تەييارلاش; ئەکىپچىلىك قىيمەسىدەك تەڭشەش، كۈنىڭىز بەلگىسىدا كىرگۈزۈش",
	jcdyf:"ئۇسۇللۇق ئەكىپچىلىك قىيمىسى",
	yhdyf:"ئەکىپچىلىك قىيمىسى",
	zhye:"ھەساب بىلەن",
	xhye:"سىگنال بىلەن",
	yf:"ئاي",
	bkxzjygz:"ھازىر تىلەشكە ئالىنmaydۇ",
	bksrjycs:"ھازىر كىرگۈزۈشكە ئالىنmaydۇ",
	hand:"يۈركەك",
	pcjl:"ئۇچرۇنما قىلىشىڭىزنى مەنئە قىلىش",
	tdxx:"تىمى مەلۇماتلىرى",
	wdyqm:"مەنىڭ قۇرۇلۇش كودۇم",
	fz:"كۆپىيە قىلىش",
	yqmsjh:"تىزمە قۇرۇلۇش كودى / تېلېفون نۇمۇرى",
	bangd:"بىلەشكە تەسىللەش",
	agree:"مەن رازىم",
	mzsm:"چۈشەندۈرۈش بىلەن",
	and:"بىلەن",
	fwtk:"ھىزمەت شەرىتلىرى",
	qhyy:"تىل تەڭشەش",
	zhong:"چىنىي تىلى",
	ying:"ئىنگلىز تىلى",
	wei:"ئۇيغۇر تىلى",
	tai:"تەئيلىك تىلى",
	han:"ھەنزۇ تىلى",
	ri:"ياپۇنچە",
	
	kyye:"مۇمكىن بولغان JCLHoin بىلەن",
	zffs:"پلايۇش يولى",
	yets:"JCLHoin بىر خىل ھېسابات بەلگىسى بولۇپ، پەقەت JCLH جەمئىيىتى ئىچىدە ئىشلىتىلىدۇ، ئىشلەتكۈچىلەر ئارىسىدا يۆتكەش ياكى قايتۇرۇۋېلىش مۇمكىن ئەمەس. بۇ JCLH تەرىپىدىن باشقۇرۇلىدۇ. پۇنكت سېتىۋېلىش ئارقىلىق ئالماشتۇرۇشقا بولىدۇ. JCLHoin مۇشتەرى بولۇش ھەققى، مۇكاپات ئالماشتۇرۇش ۋە باشقا بېكەت ئىچى ھەرىكەتلەر ئۈچۈن تۆلەشكە ئىشلىتىلىدۇ. تەپسىلاتلارنى «JCLHoin سېتىۋېلىش ۋە ئىشلىتىش كېلىشىمى» دىن كۆرۈڭ.",
	
	szhb:"سىلەيلى پۇل",
	wxzf:"ۋېچەن پلايۇش",
	zfb:"ز支付宝",
	yl:"يۇئەنلەن",
	xyk:"كىتاپ قارزى",
	szjl:"چىقىش-كىرگۈزۈش تەرىفى",
	
	szsj:"زەمەن",
	szsl:"مىقدار",
	szxm:"پروژه",
	szzt:"سودا تۆرى",
	szbh:"سودا نومۇرى",
	
	dqdj:"ھازىركى سەن",
	yxq:"ئىچكىگە",
	shengj:"يۇقىرىلىش",
	hygm:"JCLH ئەھۋالدىن كېلىشكە خوش ئالىمىز",
	zfje:"پلايۇش مىقدارى",
	xfjl:"بەلگىلەش تەرىفى",
	xfje:"مىقدار",
	dzgl:"باغلاش",
	dzg:"بىر",
	dzzh:"ھېسابات",
	
	a1:'ئېلان قىلىنغان سانى',
	a2:'ئەزالىق دەرىجىسى',
	a3:'ھېساب سانى',
	a4:'ئىشلەش',
	a5:'ئاپلود قىلىشىكى ئالدەتتىكى سۈتۈر',
	a6:'پول تۆلەش مۇۋاپىقىيەتلىك',
	a7:'پول تۆلەش بەكەر',
	a8:'ئالدەتتىكى سۈتۈرنى ئاپلود قىلىش',
	a9:'پول تۆلەشىنى كۆرۈش',
	a10:'پول تۆلەش',
	a11:'ديجىتال پول',
	a12:'كۈلپەك ئادرېسى',
	a13:'ئادرېسىنى كاپىيەلەش',
	a14:'پول تۆلەش ئۈچۈن كۈلپەك ئادرېسىنى كاپىيەلەش',
	a15:'QR كودى',
	a16:'مەڭگى',
	a17:'تەكشۈرۈش',
	a18:'بېكەرلەش',
	a19:'ئاپتۇرۇش',
	a20:'كاپىيەلەش مۇۋاپىقىيەتلىك',
	a21:'ئالدەتتىكى سۈتۈرنى ئاپلود قىلىش',
	a22:'ئالدەتتىكى سۈتۈرنى كۆرۈش',
	a23:'تەكشۈرۈشكى دەۋر',
	a24:'كېمەلەك پۈل ھەمدەك سىزىقى',
	a25:'تەكلىك قىممەت ھەمدەك سىزىقى',
	a26:'ئىشلەتكىلى بولىدىغان پۈل ھەمدەك سىزىقى',
	a27:'سودا چىقىمى ھەمدەك سىزىقى',
	a28:'سىزىقى تەكلىك بولغان سانى ھەمدەك سىزىقى',
	a29:'ئەكسىدەك سودا كۆچۈرۈش',
	a30:'پوزىتىيە ئېچىشكە قايتۇرۇش',
	a31:'پوزىتىيە ياپقۇشكە قايتۇرۇش',
	a32:'سىلتىنمىش',
	a33:'ھازىركى ئېككوانت ئاچقىلى بولىدۇmu',
	a34:'ھازىركى ئېككوانت ۋاقытلىقى توختىتىلىدۇmu',
	a35:'ھەمزمانلىقى ئىشلەتكەنلىك',
	a36:'بىر ئەككۇنتكە چەكلىك',
	a37:'ئەككۇنت سېتىشىنىڭ سانىغا چەكلىك يوق',
	a38:'سىنالەمچە نەشرىدىكى ئەئىلە',
	a39:'ئاساسىي نەشرىدىكى ئەئىلە',
	a40:'پروفېشىونال نەشرىدىكى ئەئىلە',
	a41:'ئىنتىتۇت نەشرىدىكى ئەئىلە',
	a42:'كېلەك تېلېفون نومۇرىنى تەڭشىڭىز لۇتفەن',
	a43:'ئىمېل ئادرېسىنى تەڭشىڭىز لۇتفەن',
	a44:'دەستۈر کودىنى كىرگۈزۈڭىز لۇتفەن',
	a45:'پروفىل سۈرىتىنى يۈكلىڭىز بىرەك JPG فورمىتىدە بولۇشى كېرەك!',
	a46:'پروفىل سۈرىتىنى يۈكلىڭىز بىرەك چوڭلۇقى 2MB دىن چوڭ بولماۋالىدۇ!',
	a47:'ھازىرچە سىڭكىرون داتىسى يوق',
	a48:'جۇملىك لوت سانى',
	a49:'ئۇنى ~ گە تەڭشەمۇچە؟',
	a50:'ئىشلەتكەنلىككە ئاكتىپ قىلىش',
	a51:'ئىشلەتكەنلىككەنلىككە ناكتىپ قىلىش',
	a52:'حالەت',
	a53:'بۈگۈنكى ئەككۇنتىنى ئەكلىپ چىقىرmaqچىمۇسىز؟',
	a54:'كۆچۈرۈلدى！',
	a55:'تىزىملىك پارامېتىرىنى كىرگۈزۈڭىز لۇتفەن',
	a56:'يېڭى پارول بىلەن تەكشۈرۈش پارولى بىرلەشكەنلىككەرىدىكى يوق!',
	a57:'كۈنلىك فايدىسى',
	a58:'ئورتاق',
	a59:'ئەڭ چوڭ',
	a60:'يېڭىلەش ئۇچۇرلىقى بولدى',
	a61:'پىرودۇكتىۋىتى',
	a62:'سۇتۇرغۇچ بولمىدى',
	a63:'سۇتۇرغۇچ بولدى',
	a64:'كالەن سانى',
	a65:'پۈل چىقىرىش',
	a66:'پۈل كىرگۈزۈش',
	a67:'قالبقىلىقى',
	a68:'نېتۇ فايدىسى',
	a69:'كۈنلىك فايدى/زىيان',
	a70:'سانلىقىدىكى قىممەتىنى كىرگۈزۈڭىز لۇتفەن',
	a71:'بۈگۈنكى سىگنالدىكى سىڭكىرونلۇقىدىكى خۇشال ھازىرچە يوق',
	a72:'ئالدېرىسكە چىقىش حالىسىنىڭ مۇددىسى ئەتمىگەن، قايتا ئالدېرىسكە چىقىڭ！',
	a73:'كىچىك خەت يوللانغان، ئىزدەپ ئېلىشىڭىزغا دىققەت قىلىڭ.',
	a74:'تەكشۈرۈش كودى يوللانغان！',
	a75:'ئالدېرىسكە چىقىش ئۇچۇرلىقى بولدى！',
	a76:'ئۇچۇرغۇچىڭىزىڭ ئاتى بوش بولماۋالىدۇ',
	a77:'كېلەك تېلېفون نومۇرى بوش بولماۋالىدۇ',
	a78:'ئۇچۇرغۇچى شەرىتى بىلەن شەخسىي ئۇچۇر سىياسىتىغا رەھمەت بەكەنمىگەن',
	a79:'ئەئىلە يېڭىلەش',
	a80:'تىپىنى تالاب',
	a81:'ھازىركى مۇددىسى',
	a82:'ھيسابلانغان مۇددىسى',
	a83:'ئىشارە：ھيسابلانغان كېيىنكى مۇددىسى سىستېمى ئاپتوماتىك ھيسابلاش ئېلىنغان.',
	a84:'ھۆججىتتىنى بۇغرا چىقىرىپ بۈگۈنكى جايغا',
	a85:'ياكى',
	a86:'بېكىپ يۈكلىش',
	a87:'سىز ئەڭ يۇقىرى دەرىجىسىدىكى ئەئىلەمۇسىز، يېڭىلەشكە بولماۋالىدۇ.',
	a88:'سىزىقشەك ئىچىدە',
	a89:'بۈگۈنكى پۈل چىقىرىش ئۇسۇلىسى ھازىرچە دەستۈرلەنمەگەن',
	a90:'پارولنى قايتا تەڭشىش',
	a91:'ئىنتىپ بولدى',
	a92:'ئەمېرىكىيە',
	a93:'جۇڭگو',
	a94:'ھېڭگېڭ',
	
	
	a95:'ئېغىرىم ئەسكەرتكۇچ',
	a96:'بۈگۈنكى ئەقىللىكلىك كوانتىتىتىپ جۇمھۇرىيىمىز نېمىسىمۇ standartlaşirilغان سودا сигناللىرىنى بېرىدۇ، ئۇچۇرغۇچىلەر ئىچۈن رېفېرېنسى قىلىپ ئىشلەتكىلىدۇ.',
	a97:'سىستېمىڭ ئىشلەش قۇچىسىنى ئىلگىرى ساقلىmaq و ئىشلەتكەن خاتالىقىنىنىن چەكلىمەك ئۈچۈن',
	a98:'بىر تەك كوانتىتىتىپ نىشانىسىنىڭ پۈل چەكلىكىسى 20000 USD دىن كىچىك بولماسلىقىغا سولۇم قىلىمىز.',
	a99:'ئەگەر قوزغاتقان پۈل بۈگۈنكى چەكلىكىدەن كىچىك بولسا، پۈل چەكلىكىسى كىچىكلىكى سەبەپتە قىسقارماقچى ئېغىرىم كۈچلەنمەكچى بولىدۇ، سىستېمىڭ ئىشلەش ئىstiqrarini تەسىر قىلىدۇ.',
	a100:'سىزھەر قايسى دىم ئىشلەش بېرىش ئۈچۈن بۈگۈنكى خىزمەتلىرىڭىزنىڭ پۈل ھالىتىسى و ئېغىرىم بەكچىلىكىگە ھەممەكچىلىك بىلەن ئاساسەن قىلىڭ.',
	a101:'ئەccount-ىڭىزنىڭ ئېغىرىم قورغۇ机制ىنى ئەگەرلەر بىلەن تەڭشىڭىز.',
	a102:'ھەممە كوانتىتىتىپ سودا خىزمەتلىرى سىزھەرning ئەگەرلەرلىك ئىسلاملىق قەرارلىرىدەن ئەكىدۇ، قانۇنلۇق كۈمۈش و خېرەكلىك، سودا ئۆزگەرىشى، سىستېمىخاتالىقى، سىياسەت ئۆزگەرىشى وغا ئەكىدىگەن كۈچلۈكلىك چەكلىمەگەن فاکتورلەر سەبەپتە كۆركەن خېرەكلىك',
	a103:'ھەممىسى سىزھەرning ئەگەرلەرلىك چەكلىكىدەن ئەكىدۇ.',
	a104:'بۈگۈنكى جۇمھۇرىيىمىز بېرگەن сигناللىر ئەتنىمۇ ئۇچۇر رېفېرېنسىسىدەن ئەكىدۇ.',
	a105:'سودا يۈكلىمەكچى ئۇيغۇرچە ئۇچۇر، سودا ئىстеك ياكى قانۇنلۇق كورغۇمىسىدەن ئەكىمەس.',
	a106:'بۈگۈنكى ئەقىللىكلىك كوانتىتىتىپ جۇمھۇرىيىمىز',
	a107:'قايسى دىم سودا نەتىجىسى ياكى پۈل خېرەكلىكىسىگە قانۇنلۇق چەكلىكىدەن ئەكىمەس.',
	a108:'بۈگۈنكى ئېغىرىملىرىنىڭ ھەممىسىنى تونۇشقان و قوبۇل قىلىپ تەكشۈرگەن سىزھەر ئۇزۇنلۇقىدە ئىشلەش بېرىڭ.',
	a109:'مەنمۇ بۈگۈن بىلەن تونۇشقان',
	
	zhlb:'ھەقىقەت تىزىمى',
	
	a110:'ھازىرلەكچە دەرەجە يوق',
}
